<!--
    The account's Pendenzen. Selectors: account-todos, account-todos-status (data-status),
    account-todos-new, account-todos-row (data-note-id, data-done, data-overdue), account-todos-done,
    account-todos-anchor, account-todos-empty, account-todos-error, account-todos-loading.
-->
<div class="todos" data-testid="account-todos">
    <div class="todos__bar">
        <div class="todos__pills">
            <ham-filter-pill
                data-testid="account-todos-status"
                *ngFor="let key of statuses"
                [attr.data-status]="key"
                [label]="statusLabelKey(key) | i18next"
                [count]="countOf(key)"
                [active]="key === status"
                (pillClick)="status = key"
            ></ham-filter-pill>
        </div>
        <ham-button
            data-testid="account-todos-new"
            variant="primary"
            size="toolbar"
            icon="assets/hamIcons/plus-outline.svg"
            (buttonClick)="createRequested.emit()"
        >
            {{ 'aumico_abcp_notes_new_todo' | i18next }}
        </ham-button>
    </div>

    <div class="todos__state" data-testid="account-todos-loading" *ngIf="loading && items.length === 0">
        <div class="todos__skeleton" *ngFor="let _ of [1, 2, 3]"></div>
    </div>

    <div class="todos__state todos__state--error" data-testid="account-todos-error" *ngIf="!loading && error">
        <span>{{ 'aumico_abcp_notes_overview_error' | i18next }}</span>
        <ham-button variant="white" size="sm" (buttonClick)="retryRequested.emit()">
            {{ 'aumico_abcp_notes_retry' | i18next }}
        </ham-button>
    </div>

    <ng-container *ngIf="!error && !(loading && items.length === 0)">
        <div class="todos__state" data-testid="account-todos-empty" *ngIf="shown.length === 0">
            {{
                (status === 'open'
                    ? 'aumico_abcp_notes_account_todos_empty_open'
                    : 'aumico_abcp_notes_account_todos_empty_done'
                ) | i18next
            }}
        </div>

        <ul class="todos__list" *ngIf="shown.length > 0">
            <li
                class="todos__row"
                data-testid="account-todos-row"
                role="button"
                tabindex="0"
                *ngFor="let item of shown; trackBy: trackById"
                [attr.data-note-id]="item.id"
                [attr.data-done]="item.done ? '' : null"
                [attr.data-overdue]="item.overdue ? '' : null"
                (click)="onRowOpen(item)"
                (keydown.enter)="onRowOpen(item)"
                (keydown.space)="onRowOpen(item); $event.preventDefault()"
            >
                <!-- The register's round check; a native button inside this component's own template. -->
                <button
                    type="button"
                    class="todos__check"
                    data-testid="account-todos-done"
                    role="checkbox"
                    [attr.aria-checked]="item.done"
                    [attr.aria-label]="'aumico_abcp_notes_done_toggle' | i18next"
                    (click)="onDoneToggle(item, $event)"
                >
                    <lucide-icon name="check" [size]="11" aria-hidden="true"></lucide-icon>
                </button>

                <div class="todos__body">
                    <div
                        class="todos__text"
                        [hamTooltip]="item.text"
                        tooltipClass="abcp"
                        [tooltipOnlyWhenTruncated]="true"
                    >
                        {{ item.text }}
                    </div>
                    <div class="todos__meta">
                        <span
                            class="todos__tag"
                            data-testid="notes-tag"
                            *ngFor="let tag of item.tags"
                            [attr.data-tag]="tag"
                        >
                            {{ 'aumico_abcp_notes_tag_' + tag | lowercase | i18next }}
                        </span>
                        <span class="todos__due" *ngIf="item.dueLabel">{{ item.dueLabel }}</span>
                        <ham-avatar
                            *ngIf="item.assignee"
                            data-testid="notes-assignee"
                            [attr.data-assignee-id]="item.assignee.id"
                            type="circle"
                            size="xs"
                            variant="grey-border"
                            [fullName]="item.assignee.name ?? '?'"
                            [hamTooltip]="item.assignee.name ?? ''"
                            tooltipClass="abcp"
                        ></ham-avatar>
                        <ham-button
                            class="todos__anchor"
                            data-testid="account-todos-anchor"
                            *ngIf="item.anchor"
                            variant="transparent"
                            size="xxs"
                            lucideIcon="link"
                            [hideText]="true"
                            [hamTooltip]="'aumico_abcp_notes_anchor_open' | i18next"
                            tooltipClass="abcp"
                            (click)="$event.stopPropagation()"
                            (keydown)="$event.stopPropagation()"
                            (buttonClick)="anchorOpen.emit(item)"
                        >
                            {{ 'aumico_abcp_notes_anchor_open' | i18next }}
                        </ham-button>
                    </div>
                </div>
            </li>
        </ul>
    </ng-container>
</div>
